<template>
  <div class="">
    <div class="card">
      <div class="card-body p-12">
        <!-- <form id="order_create_form" @submit.prevent> -->
          <div class="d-flex flex-column align-items-start flex-xxl-row">
            <div class="d-flex flex-row">
              <i class="fas fa-arrow-left fs-1 me-10" style="cursor:pointer" @click="$router.go(-1)"></i>
              <div>
                <div class="d-flex">
                  <h2 class="card-title mb-0 me-5">วันที่ : {{ formatDateFromISO(currentDate) }}</h2>             
                  <!-- <order-status :status="orderStatus"></order-status> -->
                </div>                
              </div>
            </div>   
          </div>
          <div class="card my-5 bg-light rounded fs-6">
         
            <div class="card-body text-gray-700"> 
              <div class="row">
                <!--begin::Col-->
                <div class="col-lg-6 pe-lg-10">                  
                  <div class=" mb-3 d-flex align-items-center ">
                    <label class="fs-4 fw-bolder  text-gray-500"
                      >ลูกค้า</label
                    >
                    <button
                      v-if="customerName"
                      class="btn btn-text-primary fs-6 py-0 pe-0 d-flex flex-row"
                      type="button"
                      @click="openCustomerModal"
                    >
                      <i class="bi bi-pencil-square mt-1"></i>
                        แก้ไข
                    </button>
                  </div>
                  <div v-if="customerName">
                    <div class="d-flex mb-2">
                      <div class="fw-bolder me-5 " style="width: 90px">ชื่อลูกค้า</div>
                      <div>{{ customerName }}</div>
                    </div>
                    <div class="d-flex mb-2">
                      <div class="fw-bolder me-5 "  style="width: 90px">เบอร์โทรศัพท์</div>
                      <div>{{ customerMobile }}</div>
                    </div>
                    <div class="d-flex flex-row mb-2">
                      <div class="fw-bolder me-5 "  style="width: 90px">ที่อยู่</div>
                      <div class="w-300px">
                        <el-input
                          type="textarea"
                          placeholder="ที่อยู่"
                          v-model="customerAddressShow"
                          :disabled="!customerID"
                          maxlength="200"
                          show-word-limit
                          rows="3"
                        >
                        </el-input>
                      </div>
                      <!-- <div style="white-space: initial; word-wrap: break-word;">{{ customerAddress }}</div> -->
                    </div>
                  </div>
                  <div v-else>
                    
                    <el-button type="primary" native-type="button" plain @click="openCustomerModal">เลือกลูกค้า</el-button>
                  
                  </div>
                  <!--begin::Input group-->
                  
                  <!--end::Input group-->
                </div>
                <!--end::Col-->
                <!--begin::Col-->
                <div class="col-lg-6">
                  <div
                    class="
                      separator separator-dashed
                      border-gray-500
                      my-5
                      d-md-none
                    "
                  ></div>
                  <div class=" mb-3 d-flex align-items-center">
                    <!-- <el-checkbox 
                      v-model="requestTaxInvoice" 
                      :disabled="!customerID"
                      class="invoice-check-box" 
                      @change="onRequestTaxInvoiceChangeHandler">ต้องการใบกำกับภาษี</el-checkbox>
                     -->
                    <label v-if="!isSellRequest" class="fs-4 fw-bolder text-gray-500"
                      >*ข้อมูลใบกำกับภาษี</label
                    >
                    <label v-else class="fs-4 fw-bolder text-gray-500"
                      >ข้อมูลใบกำกับภาษี</label
                    >
                    <button
                      v-if="requestTaxInvoice && customerTaxName "
                      class="btn btn-text-primary fs-6 py-0 pe-0 d-flex flex-row"
                      type="button"
                      @click="openCustomerAddressModal"
                    >
                      <i class="bi bi-pencil-square mt-1"></i>
                        แก้ไข
                    </button>
                  </div>
                  <div v-if="requestTaxInvoice">
                    <div v-if="customerTaxName">
                      <div class="d-flex mb-2">
                        <div class="w-160px fw-bolder me-5">ชื่อ</div>
                        <div>{{ customerTaxName }}</div>
                      </div>
                      <div class="d-flex mb-2">
                        <div class="w-160px fw-bolder me-5">ที่อยู่</div>
                        <div>{{ customerTaxAddress }}</div>
                      </div>
                      <div class="d-flex mb-2"  v-if="(customerTaxID&&customerTaxID.trim() != '')" >
                        <div class="w-160px fw-bolder me-5">
                          เลขประจำตัวผู้เสียภาษี
                        </div>
                        <div>
                          {{ customerTaxID }} &nbsp; &nbsp;
                          {{
                            !customerTaxBranch ||
                            customerTaxBranch.trim() === ""
                              ? "สำนักงานใหญ่"
                              : customerTaxBranch
                          }}
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <el-button type="primary" native-type="button" :disabled="!(customerID > 0)" plain @click="openCustomerAddressModal">เลือกที่อยู่ออกบิล</el-button>
                      <!-- <button class="btn btn-outline-primary" type="button" @click="$refs.customerAddressModal.show">
                        เลือกที่อยู่ออกบิล
                      </button> -->
                      
                    </div>
                  </div>
                  <!--end::Input group-->
                  <!--begin::Input group-->

                  <!--end::Input group-->
                </div>
              </div>
            </div>
            <!--end::Col-->
          </div>
          <div class="table-responsive">
            <!--begin::Table-->
            <table
              class="table g-5 gs-0 mb-0 fw-bolder text-gray-700"
              data-kt-element="items"
            >
              <!--begin::Table head-->
              <thead>
                <tr
                  class="
                    border-bottom
                    fs-7
                    fw-bolder
                    text-gray-700 text-uppercase
                  "
                >
                  <th class="min-w-50px w-50px">#</th>
                  <th class="min-w-300px w-475px">สินค้า</th>
                  <th class="min-w-90px w-90px">จำนวน</th>
                  <!-- <th class="min-w-100px w-100px text-end">น้ำหนัก</th> -->
                  <th class="min-w-150px w-100px text-center">ราคา(บาท/หน่วย)</th>
                  <th class="min-w-150px w-100px text-end">กำไร(บาท/หน่วย)</th>
                  <th class="min-w-120px w-100px text-end">น้ำหนักรวม(กก.)</th>
                  <th class="min-w-100px w-150px text-end">ราคารวม(บาท)</th>
                  <th class="min-w-75px w-75px text-end"></th>
                </tr>
              </thead>
              <!--end::Table head-->
              <!--begin::Table body-->
              <tbody>
                <tr
                  class="border-bottom border-bottom-dashed"
                  data-kt-element="item"
                  v-for="(product, index) in products"
                  :key="index"
                >
                  <td class="pt-8 pe-7">
                    {{ index + 1 }}
                  </td>
                  <td class="pt-8 pe-7">
                    {{ product.productName }} [{{
                      numberWithCommas(product.productWeight)
                    }}
                    กก.]
                  </td>
                  <td class="ps-0">
                    
                    <NumberInput 
                      v-model="product.quantity" :decimal="0" :max="!isSellRequest?product.stockQuantity:null" :min="1" placeholder="จำนวน"/>
                    
                  </td>
                  <td>
                    <NumberInput 
                      v-model="product.sellingPrice" :decimal="0" :min="product.minPriceIncVat" :max="product.maxPrice"/>     
                  </td>
                  <!-- กำไร -->
                  <td class="pt-8 text-end text-nowrap">
                      {{
                        numberWithCommas(((product.sellingPrice * 100.0) / (100.0 + this.vatRate)) - product.costPrice)
                      }}       
                  </td>
                  <!-- น้ำหนักรวม -->
                  <td class="pt-8 text-end text-nowrap">
                    <span data-kt-element="total">{{
                      numberWithCommas(sumWeight(product))
                    }}</span>
                  </td>
                  <!-- ราคารวม -->
                  <td class="pt-8 text-end text-nowrap">
                    <span data-kt-element="total">{{
                      numberWithCommas(sumPrice(product))
                    }}</span>
                  </td>
                  <td class="pt-5 text-end">
                    <button
                      type="button"
                      class="btn btn-sm btn-icon btn-active-color-primary"
                      data-kt-element="remove-item"
                      @click="() => deleteProduct(index)"
                    >
                      <!--begin::Svg Icon | path: icons/duotune/general/gen027.svg-->
                      <span class="svg-icon svg-icon-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                            fill="black"
                          ></path>
                          <path
                            opacity="0.5"
                            d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                            fill="black"
                          ></path>
                          <path
                            opacity="0.5"
                            d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                      <!--end::Svg Icon-->
                    </button>
                  </td>
                </tr>
              </tbody>
              <!--end::Table body-->
              <!--begin::Table foot-->

              <!--end::Table foot-->
            </table>
            <div class="text-center p-10" v-if="products.length == 0">
              <!-- <p class="fs-4 fw-bolder text-gray-500 mb-10">
                ไม่มีรายการสินค้า
              </p> -->
              <button
                class="btn btn-text-primary"
                type="button"
                @click="showSearchProductModal"
              >
                เพิ่มสินค้า
              </button>
            </div>
          </div>

          <div class="separator separator-dashed mb-5"></div>
          <div class="row fw-bolder text-gray-700">
            <div class="col-md-6 mb-10">
              <button
                class="btn btn-light-primary"
                type="button"
                @click="showSearchProductModal"
              >
                เพิ่มสินค้า
              </button>

              <div class="mt-10">
                <label class="form-label fs-6 fw-bolder text-gray-700 mb-3"
                  >หมายเหตุ</label
                >
                <div class="mb-5">
                  <el-input
                    type="textarea"
                    placeholder="หมายเหตุ"
                    v-model="remark"
                    maxlength="200"
                    show-word-limit
                    rows="3"
                  >
                  </el-input>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-5 offset-lg-1 fs-5 fw-bolder">
              <div class="
                text-gray-700
                fs-6
                card
                bg-light
                rounded-3
                mb-3">
                <div class="card-body">
                  <div class="d-flex flex-row justify-content-between mb-6">
                    <div>น้ำหนักรวม (กก.)</div>
                    <div>{{ numberWithCommas(totalWeight) }}</div>
                  </div>
                  <div class="d-flex flex-row justify-content-between mb-2">
                    <div>รวมเป็นเงิน</div>
                    <div>{{ numberWithCommas(subTotal) }}</div>
                  </div>
                  <div class="d-flex flex-row justify-content-between mb-2">
                    <div>ภาษีมูลค่าเพิ่ม {{ vatRate }}%</div>
                    <div>{{ numberWithCommas(vat) }}</div>
                  </div>
                  <div class="d-flex flex-row justify-content-between">
                    <div>ราคาไม่รวมภาษีมูลค่าเพิ่ม</div>
                    <div>{{ numberWithCommas(totalExcludeVat) }}</div>
                  </div>
                  <div class="
                      separator separator-dashed
                      my-5
                      border-1 border-gray-400"
                  ></div>
                  <div class="d-flex flex-row justify-content-between fs-4">
                    <div>จำนวนเงินรวมทั้งสิ้น</div>
                    <div>{{ numberWithCommas(total) }}</div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary w-100" type="submit" @click="submit">ยืนยัน</button>
            </div>
          </div>
        <!-- </form> -->
      </div>
    </div>
    <search-customer-modal
      ref="customerModal"
      @select="onSelectCustomer"
    ></search-customer-modal>
    <search-customer-address-modal
      ref="customerAddressModal"
      @select="onSelectAddress"
      :customerId="customerID"
    ></search-customer-address-modal>
    <search-product-modal
      v-model="products"
      ref="searchProductModalRef"
      :isSR="isSellRequest"
    ></search-product-modal>
  </div>
</template>

<script>
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { numberWithCommas, formatDateFromISO } from "@/utils";
// import OrderStatus from "@/components/status/OrderStatus";
import SearchCustomerModal from "@/components/modals/search/SearchCustomerModal";
import SearchCustomerAddressModal from "@/components/modals/search/SearchCustomerAddressModal";
import SearchProductModal from "@/components/modals/search/SearchProductModal";
import ApiService from "@/core/services/ApiService";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { DateTime } from "luxon";
// import VueNumericInput from 'vue-numeric-input'

import NumberInput from '@/components/forms/NumberInput'

export default {
  components: {
    SearchCustomerModal,
    SearchProductModal,
    SearchCustomerAddressModal,
    // VueNumericInput
    NumberInput,
    // OrderStatus
  },
  data() {
    return {
      value1: new Date(),
      vatRate: 7,
      remark: null,
      customerID: null,
      customerName: null,
      customerMobile: null,
      customerAddress: "",
      CustomerAddressShow:"",
      customerTaxName: "",
      customerTaxAddress: "",
      customerTaxID: "",
      customerTaxBranch: "",
      customerAddressID: 0,
      ssCustomerID: null,
      products: [],
      requestTaxInvoice: true,
      currentDate: null,
      isSellRequest:(this.$route != null && this.$route.fullPath.includes("sellrequest"))?true:false
    };
  },
  computed: {
    totalWeight() {
      return this.products.reduce((acc, curr) => acc + this.sumWeight(curr), 0);
    },
    subTotal() {
      return this.products.reduce((acc, curr) => acc + this.sumPrice(curr), 0);
    },
    total() {
      return this.subTotal;
    },
    totalExcludeVat() {
      return ((this.total * 100.0) / (100.0 + this.vatRate)).toFixed(2);
    },
    vat() {
      return (this.total - this.totalExcludeVat).toFixed(2);
    }
    // productSortByCode() {
    //   return this.products.sort((a, b) => a.productCode - b.productCode);
    // }
  },
  watch: {
    "$route.query.prods": {
      immediate: true,
      handler: function (val) {
        if (!val || val.length == 0) return;
        if (Array.isArray(val)) {
          this.findProducts(val);
        } else {
          this.findProducts([val]);
        }
        // console.log(val)
      },
    },
  },
  mounted() {
    setCurrentPageBreadcrumbs((this.$route != null && this.$route.fullPath.includes("sellrequest"))?"ใบเสนอราคา":"เปิดบิล", ["รายการขาย"]);
    this.currentDate = DateTime.now();
    this.GetVatRate();
  },
  methods: {
    GetVatRate: async function (){
          await ApiService.get("campaign/GetVatRate", '2S')
            .then((res) => {
                this.vatRate = res.data
            })
    },
    findProducts: async function (productIds) {
      const { data } = await ApiService.query("products", {
        params: { productIds: productIds.join() },
      });

      this.products = data
      this.products.sort((a, b) => a.productCode - b.productCode )
      this.products.forEach(p => p.maxPrice = p.sellingPrice);
    },
    addProduct() {
      this.products.push({
        productName: "",
        price: null,
        quantity: null,
        productWeight: 5,
      });
    },
    deleteProduct(index) {
      this.products.splice(index, 1);
    },
    sumPrice(product) {
      const { sellingPrice, quantity } = product;
      return (
        (isNaN(sellingPrice) ? 0 : sellingPrice) *
        (isNaN(quantity) ? 0 : quantity)
      );
    },
    sumWeight(product) {
      const { productWeight, quantity } = product;
      return (
        (isNaN(productWeight) ? 0 : productWeight) *
        (isNaN(quantity) ? 0 : quantity)
      );
    },
    openCustomerModal() {
      this.$refs.customerModal.show();
    },
    openCustomerAddressModal() {
      this.$refs.customerAddressModal.show();
    },
    showSearchProductModal() {
      this.$refs.searchProductModalRef.show();
    },
    onRequestTaxInvoiceChangeHandler(checked) {
      if(checked) return        

        this.customerTaxName = null;
        this.customerTaxAddress = null;
        this.customerTaxID = null;
        this.customerTaxBranch = null;      
    },
    onSelectCustomer(customer) {
      this.customerID = customer.customerID;
      this.customerCode = customer.customerCode;
      this.customerName = customer.customerName;
      this.customerAddress = customer.customerAddress;
      this.customerAddressShow = customer.customerAddressShow;
      this.customerMobile = customer.customerMobile;
      this.customerTaxName = null;
      this.customerTaxAddress = null;
      this.customerTaxID = null;
      this.customerTaxBranch = null;
    },
    onSelectAddress(address) {
      this.customerTaxName = address.custAddrName;
      this.customerTaxAddress = address.custAddrShow;
      this.customerTaxID = address.custAddrTaxID;
      this.customerTaxBranch = address.custAddrTaxBranch;
      this.ssCustomerID = address.ssCustomerID;
      this.customerAddressID = address.custAddrID;
    },
    submit: async function () {
      if (!this.customerID) {
        return Swal.fire({
          text: "กรุณาเลือกลูกค้า",
          icon: "error",
          confirmButtonText: "ปิด",
        });
      }
      if (this.products.length == 0) {
        return Swal.fire({
          text: "กรุณาเลือกสินค้า",
          icon: "error",
          confirmButtonText: "ปิด",
        });
      } else if(this.products.filter(p => p.sellingPrice <= 0 ).length > 0) {
        return Swal.fire({
          text: "กรุณากำหนดราคาสินค้า",
          icon: "error",
          confirmButtonText: "ปิด",
        });
      }
      if(this.products.filter(p => p.quantity <= 0 ).length > 0) {
        return Swal.fire({
          text: "กรุณากำหนดจำนวนสินค้า",
          icon: "error",
          confirmButtonText: "ปิด",
        });
      }
      if(!this.isSellRequest){
        if (this.requestTaxInvoice && !this.customerTaxID ) {
          return Swal.fire({
            text: "กรุณาเลือกที่อยู่สำหรับออกใบกำกับภาษี",
            icon: "error",
            confirmButtonText: "ปิด",
          });
        }
        if(!this.customerTaxName || !this.customerTaxAddress || !this.customerTaxID){
          return Swal.fire({
            text: "กรุณาเลือกที่อยู่สำหรับออกใบกำกับภาษี",
            icon: "error",
            confirmButtonText: "ปิด",
          });
        }
      }
      Swal.fire({
        title: "กำลังบันทึก",
        html: '<div class="pb-10"><div class="spinner-border w-100px h-100px fs-1 text-primary"  role="status">  <span class="visually-hidden">Loading...</span></div></div>',
        //timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          setTimeout(() => {
            if(this.$route != null && this.$route.name == "sellrequestCreate"){
              this.createSellRequest();
            }else{
              this.createOrder();
            }
            
          }, 1000);
        },
      });
    },
    createOrder: async function () {
      try {
        const params = {
          customerID: this.customerID,
          customerName: this.customerName,
          customerAddress: this.customerAddress,
          customerMobile: this.customerMobile,
          totalWeight: this.totalWeight,
          subTotal: this.subTotal,
          discount: this.discount,
          total: this.total,
          vatRate: this.vatRate,
          vat: this.vat,
          totalExcludeVat: this.totalExcludeVat,
          remark: this.remark,
          customerTaxName: this.customerTaxName,
          customerTaxAddress: this.customerTaxAddress,
          customerTaxID: this.customerTaxID,
          customerTaxBranch: this.customerTaxBranch,
          customerAddressID: this.customerAddressID,
          ssCustomerID: this.ssCustomerID,
          requestTaxInvoice: this.requestTaxInvoice && !!this.customerTaxID && this.customerTaxID.trim().length > 0,
          details: this.products.map((p) => ({
            ...p,
            weightTotal: this.sumWeight(p),
            subTotal: this.sumPrice(p),
            productPrice: p.sellingPrice,
          })),
        };

        const { data } = await ApiService.post("orders", params);

        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          timer:1500,
          allowOutsideClick: false,
          didDestroy: () => {
            this.$router.push({name: 'orderDetail', params: {orderCode: data.orderCode}})
            // this.$router.push({ name: "sellorderreport" });
          },
        });
      } catch (error) {
        const {data, status} = error.response

        if(data.message) {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: data.message,
        });
        } else {
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: "บันทึกข้อมูลไม่สำเร็จกรุณาติดต่อผู้ดูแลระบบ",
        });
        }
      }
    },
    createSellRequest: async function () {
      //try {
        const params = {
          customerID: this.customerID,
          customerName: this.customerName,
          customerAddress: this.customerAddress,
          customerMobile: this.customerMobile,
          totalWeight: this.totalWeight,
          subTotal: this.subTotal,
          discount: this.discount,
          total: this.total,
          vatRate: this.vatRate,
          vat: this.vat,
          totalExcludeVat: this.totalExcludeVat,
          remark: this.remark,
          // customerTaxName: this.customerTaxName,
          // customerTaxAddress: this.customerTaxAddress,
          // customerTaxID: this.customerTaxID,
          // customerTaxBranch: this.customerTaxBranch,
          // customerAddressID: this.customerAddressID,
          //ssCustomerID: this.ssCustomerID,
          requestTaxInvoice: false,
          details: this.products.map((p) => ({
            ...p,
            weightTotal: this.sumWeight(p),
            subTotal: this.sumPrice(p),
            productPrice: p.sellingPrice,
          })),
        };
        if(this.customerAddressID >0){
          params.customerTaxName= this.customerTaxName;
          params.customerTaxID= this.customerTaxID;
          params.customerTaxBranch= this.customerTaxBranch;
          params.customerAddressID= this.customerAddressID;
          params.customerTaxName= this.customerTaxName;
          params.ssCustomerID= this.ssCustomerID;
          params.requestTaxInvoice= this.requestTaxInvoice && !!this.customerTaxID && this.customerTaxID.trim().length > 0;

        }

        const { data } = await ApiService.post("SellRequest/SellRequestCreate", params);
        if(data.success >0){        
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ",
            timer:1500,
            allowOutsideClick: false,
            didDestroy: () => {
              this.$router.push({name: 'SellRequestDetail', params: {srCode: data.code}})
              // this.$router.push({ name: "sellorderreport" });
            },
          });
        }else{
          Swal.fire({
              icon: "error",
              title: "เกิดข้อผิดพลาด",
              text: data.error_Text,
          });
        }
      // } catch (error) {
      //   const {data, status} = error.response

      //   if(data.message) {
      //     Swal.fire({
      //       icon: "error",
      //       title: "เกิดข้อผิดพลาด",
      //       text: data.message,
      //   });
      //   } else {
      //     Swal.fire({
      //       icon: "error",
      //       title: "เกิดข้อผิดพลาด",
      //       text: "บันทึกข้อมูลไม่สำเร็จกรุณาติดต่อผู้ดูแลระบบ",
      //   });
      //   }
      // }
    },
    numberWithCommas,
    formatDateFromISO,
  },
  
};
</script>

<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
